import React, {useCallback} from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PIMSecondaryButton} from '../../Atoms/Buttons/Bases/PIMSecondaryButton'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'

type MembersEditPasswordCompletePageProps = {
  navigator: NavigatorForMemberPage
}

export const MembersEditPasswordCompletePage: React.VFC<MembersEditPasswordCompletePageProps> = (
  props,
) => {
  const goToAccountTopPage = useCallback(() => {
    props.navigator.goToAccountTopPage()
  }, [props.navigator])

  return (
    <MembersPageTemplate>
      <PageTitle>パスワード変更完了</PageTitle>
      <ContentBlock data-testid={'block-notification'}>
        <ContentTitle>パスワード変更完了</ContentTitle>
        <ContentTopMessage>
          パスワードの変更が完了し、ログアウトしました。<br/>
          新しいパスワードでログインしてください。
        </ContentTopMessage>
      </ContentBlock>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <PIMSecondaryButton onClick={goToAccountTopPage}>
            ログインページに移動する
          </PIMSecondaryButton>
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
